import { render, staticRenderFns } from "./FutureTracker.vue?vue&type=template&id=4e85d790&scoped=true&"
import script from "./FutureTracker.vue?vue&type=script&lang=js&"
export * from "./FutureTracker.vue?vue&type=script&lang=js&"
import style0 from "./FutureTracker.vue?vue&type=style&index=0&id=4e85d790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e85d790",
  null
  
)

export default component.exports